import React from 'react';

import PropTypes from 'prop-types';

const BlueBoxHeader = ({ children }) => {
    return (
        <h3 className="blue-box-header">
            { children }
        </h3>
    );
};

BlueBoxHeader.propTypes = {
    children: PropTypes.node,
};

export default BlueBoxHeader;
